/* Package JSON Import will be here */
import React, { useEffect } from 'react'
import Quagga from 'quagga'
/* Package JSON Import will be here */

const BarCodeScanner = props => {
    useEffect(() => {
        Quagga.init(
            {
                inputStream: {
                    type: 'LiveStream',
                    constraints: {
                        width: 640,
                        height: 480,
                        facingMode: 'environment', // or user
                    },
                },
                locator: {
                    patchSize: 'medium',
                    halfSample: true,
                },
                numOfWorkers: 4,
                decoder: {
                    readers: [
                        "code_128_reader",
                        "ean_8_reader"
                    ],
                },
                locate: true,
            },
            (err) => {
                if (err) {
                    /* TODO: Need to handle the error part */
                    return null;
                }

                Quagga.start();
            },
        );

        Quagga.onDetected(onDetected);


        /* Return will work like ComponentWillUnmount */
        return () => {
            Quagga.offDetected(onDetected);
            Quagga.stop();
        };
    }, []);

    const onDetected = (result) => {
        props.onDetected(result)
    };

    return (
        <div id="interactive" className="viewport bar-code-scanner-camera" />
    );
};

export default BarCodeScanner;
